export const useImperial = { used: false };
export const loadPlan = { loaded: false };

const INCH_MULTIPLIER = 0.03937; // 1 mm = 0.0393701 inch
const FEET_MULTIPLIER = 10.7639; // 1 sq meter = 10.7639 square foot
const METER_TO_INCHES = 39.3701; // 1 meter = 39.3701 inches
const METER_TO_FEET = 3.28084; // 1 meter = 3.28084 feet

const toFixedFloat = (value, precision = 1) => parseFloat(value.toFixed(precision));

export const convertToMetric = (imperialValue) => {
  if (imperialValue === 0) return imperialValue;
  const metricValue = imperialValue / INCH_MULTIPLIER;
  return Math.ceil(toFixedFloat(metricValue, 1));
};

export const convertToImperial = (metricValue) => {
  if (metricValue === 0) return metricValue;
  return toFixedFloat(metricValue * INCH_MULTIPLIER, 1);
};

export const convertSqMeterPriceToSqFeetPrice = (sqMeterPrice, unitCode) => {
  if (unitCode !== 'METER') return sqMeterPrice;
  return toFixedFloat(sqMeterPrice / FEET_MULTIPLIER);
};

export const convertMeterPriceToFeetPrice = (meterPrice, unitCode) => {
  let price = meterPrice / METER_TO_FEET;
  const priceModolus = price % 0.01;
  if (priceModolus > 0) {
    price = Math.ceil((price * 100)) / 100;
  }
  return price;
};

export const convertSquareMeterPriceToSquareFeetPrice = (meterPrice) => {
  const price = meterPrice / FEET_MULTIPLIER;
  return Math.floor(price * 100) / 100;
};

export const convertSqMeterToSqFeet = (sqMeter, unitCode) => {
  if (unitCode !== 'METER') return sqMeter;
  return toFixedFloat(sqMeter * FEET_MULTIPLIER);
};

export const convertSqMeterToSqFeetTwoDecimals = (sqMeter, unitCode) => {
  let sqFeet;
  if (unitCode !== 'METER') {
    sqFeet = sqMeter;
  } else if (unitCode === 'METER') {
    sqFeet = sqMeter * FEET_MULTIPLIER;
    const modolus = sqFeet % 0.01;
    if (modolus > 0) {
      sqFeet = Math.ceil((sqFeet * 100)) / 100;
    }
  }
  return sqFeet;
};

export const convertMeterToInches = (meterValue) => toFixedFloat(meterValue * METER_TO_INCHES, 2);
export const convertMeterToFeet = (meterValue) => toFixedFloat(meterValue * METER_TO_FEET, 2);
